import { CanDeactivateFn } from '@angular/router';

export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
}

// Asks before leaving a page that has changes it hasn't saved
export const UnsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (
  component
) =>
  !component.hasUnsavedChanges() ||
  confirm('You have unsaved changes. Leave this page without saving them?');
